import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=4e423807&scoped=true&"
import script from "./js/setting.js?vue&type=script&lang=js&"
export * from "./js/setting.js?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=4e423807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e423807",
  null
  
)

export default component.exports